import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LanguageViewComponent } from './language-view.component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [LanguageViewComponent],
  exports: [LanguageViewComponent],
})
export class LanguageViewModule {
}
